import { Card, CardContent } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import {
  ApiKeyInfo,
  ApiKeyKopierenButton,
  ApiKeyMaskierung,
} from './ApiKeyClipboard.tsx';
import { ZugangActions } from './ZugangActions.tsx';
import { ZugangSwitch } from './ZugangSwitch.tsx';
import { ZugangZaehler } from './ZugangZaehler.tsx';
import { PartnerBadge } from './PartnerBadge.tsx';
import type { Zugang } from './ZugaengeTable.tsx';

type ZugaengeListeProps = {
  zugaenge: Zugang[];
  zugangLimit: number;
};

export function ZugaengeListe({ zugaenge, zugangLimit }: ZugaengeListeProps) {
  return (
    <div>
      <ZugangZaehler
        anzahl={zugaenge.length}
        max={zugangLimit}
        className="mb-3"
      />

      <div className="flex flex-col gap-4">
        {zugaenge.map((zugang) => (
          <ZugangKarte key={zugang.uid} zugang={zugang} />
        ))}
      </div>
    </div>
  );
}

function ZugangKarte({ zugang }: { zugang: Zugang }) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center justify-between gap-2">
          <span className="flex min-w-0 items-center gap-2">
            <span className="truncate text-sm font-semibold text-neutrals-900">
              {zugang.beschreibung}
            </span>
            {zugang.partnerTemplate && (
              <PartnerBadge
                partnerTemplate={zugang.partnerTemplate}
                infoSeite="bottom"
              />
            )}
          </span>
          <ZugangSwitch uidZugang={zugang.uid} aktiv={zugang.aktiv} />
        </div>

        <div className="mt-2 flex items-start justify-between gap-2">
          <div className="min-w-0">
            <span className="flex items-center gap-1 text-xs text-neutrals-700">
              {t('domain.e2nApi.zugaenge.tabelle.apiKey')}
              <ApiKeyInfo seite="bottom" />
            </span>
            <ApiKeyMaskierung className="text-sm text-neutrals-900" />
          </div>
          <ApiKeyKopierenButton apiKey={zugang.apiKey} />
        </div>

        <div className="mt-2">
          <ZugangActions
            uidZugang={zugang.uid}
            editierbar={zugang.partnerTemplate == null}
            darstellung="leiste"
          />
        </div>
      </CardContent>
    </Card>
  );
}
